import { NumberInput, required, TextInput, useTranslate } from 'react-admin';
import { Box, Stack, Typography } from '@mui/material';
import { CriticalHitTier } from '../../../services/redpacketService';

interface FormProps {
  isCreate: boolean;
  record?: CriticalHitTier;
}

const CriticalHitTierForm = (props: FormProps) => {
  const { isCreate, record } = props;
  const t = useTranslate();

  const numberProps = {
    parse: (v: any) => (v === '' || v == null ? undefined : Number(v)),
    format: (v: any) => (v == null ? '' : v),
    inputProps: {
      inputMode: 'decimal',
      step: 'any',
      onWheel: (e: React.WheelEvent<HTMLInputElement>) => {
        (e.currentTarget as HTMLInputElement).blur();
      },
    } as const,
  } as const;

  return (
    <Stack spacing={3} gap={2}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.amount')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <NumberInput
            label={false}
            source="amount"
            validate={[required()]}
            placeholder={t('module.redpacket.amount')}
            fullWidth
            defaultValue={record?.amount}
            {...numberProps}
          />
        </Box>
      </Stack>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.probabilityPercent')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <NumberInput
            label={false}
            source="probability"
            validate={[required()]}
            placeholder={t('module.redpacket.probabilityPlaceholder')}
            fullWidth
            defaultValue={record?.probability ? record?.probability * 100 : 0}
            {...numberProps}
            format={(v: any) => (v == null ? '' : v)}
            parse={(v: any) => {
              if (v === '' || v == null) return undefined;
              const num = Number(v);
              if (num > 100) return undefined;
              // 如果输入的是百分比形式（如5），转换为小数（0.05）
              return num > 1 ? num / 100 : num;
            }}
          />
        </Box>
      </Stack>


      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.description')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <TextInput
            label={false}
            source="description"
            placeholder={t('module.redpacket.descriptionOptional')}
            fullWidth
            multiline
            defaultValue={record?.description}
            rows={3}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default CriticalHitTierForm;
